import { render, staticRenderFns } from "./DocumentListMagyt.vue?vue&type=template&id=2c21fe0c&scoped=true&"
import script from "./DocumentListMagyt.vue?vue&type=script&lang=js&"
export * from "./DocumentListMagyt.vue?vue&type=script&lang=js&"
import style0 from "./DocumentListMagyt.vue?vue&type=style&index=0&id=2c21fe0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c21fe0c",
  null
  
)

export default component.exports